import { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider as MUIDivider, ListItemText } from '@mui/material';
import { HelpOutlineRounded } from '@mui/icons-material';
import { MainMenuItems } from '@/common/components/MainMenuItems/MainMenuItems';
import AccesibilityButtons from '@/base/layouts/components/Sidebar/AccesibilityButtons';
import { UserboxMenuButton } from './UserboxMenuButton/UserboxMenuButton';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import {
  Divider,
  MainMenuBottomWrapper,
  MainMenuContainer,
  MainMenuTopWrapper,
  MainMenuUserWrapper,
  NotificationsWrapper,
  HelpWrapper
} from './MainMenu.styles';
import { WorkspaceListItem } from '@/common/components/WorkspaceListItem/WorkspaceListItem';
import { MenuToggleContext } from '@/base/layouts/contexts/MenuToggleContext';
import { useUserStore } from '@/user/stores/userStore';

export const MainMenu = () => {
  const { t } = useTranslation();
  const { goToWorkspaces } = useContext(MenuToggleContext);
  const { currentWorkspace: current, workspaces } = useUserStore();
  const currentWorkspace = workspaces.find((w) => w.id === current);

  return (
    <MainMenuContainer>
      <MainMenuTopWrapper>
        <WorkspaceListItem
          workspace={currentWorkspace}
          onClick={goToWorkspaces}
          showUnfold
          size="large"
        />
        <Divider />
        <MainMenuItems wrapperStyles={{ px: 1 }} />
      </MainMenuTopWrapper>
      <MainMenuBottomWrapper>
        <HelpWrapper LinkComponent={'a'} href="mailto:info@guud.tv">
          <HelpOutlineRounded />
          <ListItemText primary={t('Help & support')} />
        </HelpWrapper>
        <MainMenuUserWrapper>
          <UserboxMenuButton />
          <MUIDivider
            orientation="vertical"
            flexItem
            sx={{ justifySelf: 'center' }}
          />
          <NotificationsWrapper>
            <ExpandMoreTwoToneIcon />
            <AccesibilityButtons />
          </NotificationsWrapper>
        </MainMenuUserWrapper>
      </MainMenuBottomWrapper>
    </MainMenuContainer>
  );
};
